import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import type { MediaWrapperTypeEnum } from '@/utils/aspectRatioUtils';

import type { CardProps } from '@/components/Cms/Card';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';
import { useIsMdUp } from '@/hooks/useMedia';
import { theme } from '@/theme';

import * as S from './SinceHistoryItem.styles';

export const SinceHistoryItem = (props: CardProps) => {
  const heading = props.placeholderHeading;
  const isMdUp = useIsMdUp();
  const HistoryInfoGroup = () => {
    return (
      <S.HistoryInfoGroup>
        {heading && (
          <S.HistoryInfoTitle
            Heading={
              ({
                ...heading,
                textAlignment: isMdUp ? 'left' : 'center',
              } as ContentfulCardFragment['placeholderHeading']) ?? undefined
            }
            color={heading?.mainColor ?? theme.colors.default}
            data-test-id='DefaultTypeCardPlaceholderHeading'
            isHeroSlider
          />
        )}
        {props.subHeading && (
          <S.HistoryInfoSubTitle data-testid='Since1884SubTitle'>
            {props.subHeading}
          </S.HistoryInfoSubTitle>
        )}
        {props.cardText?.json && (
          <S.HistoryInfoText
            dangerouslySetInnerHTML={{
              __html: documentToHtmlString(props.cardText?.json),
            }}
            data-testid='Since1884InfoText'
          ></S.HistoryInfoText>
        )}
      </S.HistoryInfoGroup>
    );
  };
  const HistoryItemImageGroup = () => {
    const mediaWrapperType = 'Auto' as MediaWrapperTypeEnum;
    return (
      <S.HistoryItemImageGroup>
        {props.media?.image?.url && (
          <S.ImageWrapper data-test-id='MediaAndSideTextTypeImageWrapper'>
            <MediaWrapper
              {...props.media}
              aspectRatio={props.aspectRatio}
              data-test-id='HistoriesTwoColumnImage'
              mediaWrapperType={mediaWrapperType}
              preload={props.preload}
              sizes='(max-width: 468px) 50vw, 20vw'
            />
          </S.ImageWrapper>
        )}
        {props.url2Text && props.cardText2?.json && (
          <S.DisplayDidYouKnowGroup>
            <S.DisplayDidYouKnowLabel>
              {props.url2Text}
            </S.DisplayDidYouKnowLabel>
            <S.DisplayDidYouKnowText
              dangerouslySetInnerHTML={{
                __html: documentToHtmlString(props.cardText2?.json),
              }}
              data-testid='Since1884Text'
            ></S.DisplayDidYouKnowText>
          </S.DisplayDidYouKnowGroup>
        )}
      </S.HistoryItemImageGroup>
    );
  };
  if (props.contentAlignment === 'top') {
    return (
      <S.HistoryItemWrapper
        className='grid-item'
        data-testid='HistoryItemWrapperTop'
        id={props?.id ?? '#'}
      >
        <HistoryItemImageGroup></HistoryItemImageGroup>
        <HistoryInfoGroup></HistoryInfoGroup>
      </S.HistoryItemWrapper>
    );
  } else {
    return (
      <S.HistoryItemWrapper
        className='grid-item'
        data-testid='HistoryItemWrapperBottom'
        id={props?.id ?? '#'}
      >
        <HistoryInfoGroup></HistoryInfoGroup>
        <HistoryItemImageGroup></HistoryItemImageGroup>
      </S.HistoryItemWrapper>
    );
  }
};
